import classNames from 'classnames';
import * as React from 'react';

var MenuItemImage = function MenuItemImage(_ref) {
  var icon = _ref.icon,
      image = _ref.image,
      imageWidth = _ref.imageWidth,
      imageClassName = _ref.imageClassName;

  if (icon) {
    return /*#__PURE__*/React.createElement("i", {
      className: classNames(icon, imageClassName)
    });
  }

  if (!image) {
    return null;
  }

  return /*#__PURE__*/React.createElement("img", {
    src: image,
    width: imageWidth,
    className: imageClassName
  });
};

export { MenuItemImage };